module.exports = __webpack_public_path__ + "img/bg1.586a8ba3.png";